import { createFileRoute, Navigate } from '@tanstack/react-router';
import { AdminQuoteEditPage } from '@/features/admin/admin-quote-edit-page';
import { salesGuard } from '@/lib/route-guards';
import { useQuote } from '@/services/queries/quotes';

export const Route = createFileRoute('/sales/quotes/$id/edit')({
  beforeLoad: salesGuard,
  component: SalesEditQuoteRoute,
});

function SalesEditQuoteRoute() {
  const { id } = Route.useParams();
  const { data: quote, isLoading, error, isFetched } = useQuote(id);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="flex items-center gap-3 text-slate-500">
          <span className="material-symbols-outlined animate-spin text-2xl">progress_activity</span>
          <span>Loading quote...</span>
        </div>
      </div>
    );
  }

  if (!isFetched) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="flex items-center gap-3 text-slate-500">
          <span className="material-symbols-outlined animate-spin text-2xl">progress_activity</span>
          <span>Loading quote...</span>
        </div>
      </div>
    );
  }

  if (error || !quote) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
          Quote Not Found
        </h2>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          The quote you're looking for doesn't exist or has been removed.
        </p>
      </div>
    );
  }

  // Only DRAFT quotes can be edited - redirect others to view page
  if (quote.status !== 'DRAFT') {
    return <Navigate to="/sales/quotes/$id" params={{ id }} />;
  }

  return <AdminQuoteEditPage quote={quote} quoteDetailRoute="/sales/quotes/$id" quotesListRoute="/sales/quotes" portalBase="/sales" />;
}
